import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, Button, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { APP_DEFAULT_PATH } from 'config';
import error500 from 'assets/images/maintenance/img-error-500.svg';

function AccessDenied() {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Grid container direction="column" alignItems="center" justifyContent="center" sx={{ minHeight: '100vh' }} spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ width: 325 }}>
            <img src={error500} alt="error 500" style={{ height: '100%', width: '100%' }} />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Stack justifyContent="center" alignItems="center">
            <Typography align="center" variant={matchDownSM ? 'h2' : 'h1'}>
              Permission Required
            </Typography>
            <Typography color="textSecondary" variant="body2" align="center" sx={{ width: { xs: '73%', sm: '70%', md: '100%' }, mt: 1 }}>
              Your account is authenticated, but you don’t have permission to view this page.<br />
              Please contact your organization administrator if you believe this is incorrect. <br />
              {/* <Link to="#">Learn More</Link>  */}
            </Typography>
            <Button component={Link} to={APP_DEFAULT_PATH} variant="contained" sx={{ textTransform: 'none', mt: 4 }}>
              Back To Home
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
export default AccessDenied;